import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { initSentry } from './config/sentry';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/index.css';
import './styles/theme.css';
import './styles/0_tokens.css';
import './styles/1_elements.css';
import './styles/2_components.css';
import './styles/App.css';
import './styles/components.css';
import './features/deprecation/bootstrap';
import App from './App';

// Initialize Sentry before rendering React
initSentry();

const shouldSuppressConsoleMessage = (args) =>
  args.some(
    (arg) => typeof arg === 'string' && arg.includes('Support for defaultProps will be removed')
  );

const consoleWarn = console.warn.bind(console);
const consoleError = console.error.bind(console);

console.warn = (...args) => {
  if (shouldSuppressConsoleMessage(args)) {
    return;
  }
  consoleWarn(...args);
};

console.error = (...args) => {
  if (shouldSuppressConsoleMessage(args)) {
    return;
  }
  consoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
const AppWithProfiler = Sentry.withProfiler(App);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <AppWithProfiler />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);
